module.exports = require("./ko-KP.d.ts");